export const GUEST_POPUP_CLICK_TYPE = {
  OK: "ok",
  DISCARD: "discard",
  DO_NOT_SEND_UPDATE: "do_not_send_update",
} as const;
